var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnsaveBet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29289 2.79289C5.68342 2.40237 6.31658 2.40237 6.70711 2.79289L21.7071 17.7929C22.0976 18.1834 22.0976 18.8166 21.7071 19.2071C21.3166 19.5976 20.6834 19.5976 20.2929 19.2071L5.29289 4.20711C4.90237 3.81658 4.90237 3.18342 5.29289 2.79289Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.32843V18.5369C8 19.4346 9.09122 19.8776 9.717 19.2339L12.283 16.5946C12.6757 16.1907 13.3243 16.1907 13.717 16.5946L16.283 19.2339C16.9088 19.8776 18 19.4346 18 18.5369V18.3284L8 8.32843ZM18 14.0858V16.9142L8.14912 7.06333C8.36667 6.40079 8.80874 5.84006 9.38535 5.47114L18 14.0858ZM18 12.6716V8C18 6.34315 16.6569 5 15 5H11C10.7911 5 10.5872 5.02135 10.3904 5.06198L18 12.6716Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsaveBet);
export default __webpack_public_path__ + "static/media/unsave-bet.a9a2db79349432f160ea80d708c37456.svg";
export { ForwardRef as ReactComponent };